import React from "react";
import useFetchRfqs from "../../hooks/useFetchRfqs";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { checkRoute, closeModalMenu } from "./utility";
import { ContextConstants, useAppContext } from "../../Context/AppContext";

import { useMixPanelForTracking } from "../../shared_utilities/trackMixPanel";

const NavLinkRFQ = ({ onRFQClick, path, title, history }) => {
  const isActive = history.location.pathname === path;
  return (
    <button
      onClick={() => onRFQClick(path)}
      className={`btn btn-sm btn-link text-left pb-1 pt-0`}
      style={{ fontSize: "0.8rem", color: isActive ? "#393185" : "#000" }}
    >
      {title}
    </button>
  );
};

export default function ActiveProcurementList() {
  const {TrackMixPanel} = useMixPanelForTracking()
  const { procurements, isRfqLoading } = useFetchRfqs("active");
  const { dispatch, transporterInfo, isEditable } = useAppContext();
  const history = useHistory();
  const visibleProcurements = 10;

  const onRFQClick = (path) => {
    if (window.innerWidth < 600) {
      closeModalMenu();
    }

    if (checkRoute(path, isEditable)) {
      dispatch({ type: ContextConstants.ToggleRFQ });
      history.push({ pathname: path });
    }
  };

  return (
    procurements?.length > 0 &&
    !isRfqLoading && (
      <div className="d-flex flex-column pb-2">
        {procurements?.slice(0, visibleProcurements)?.map((item) => (
          <NavLinkRFQ
            key={item.procurement_id}
            history={history}
            onRFQClick={onRFQClick}
            path={`/RFQ/${item.procurement_id}`}
            title={item.procurement_name}
            style={{ fontSize: "12px" }}
          />
        ))}

        {procurements?.length > visibleProcurements && (
          <button
            onClick={() => {
              TrackMixPanel({
                Definition:"user has clicked on the show more button.",
                ModuleName:"tpmp procurements",
                ScreenName:""
              })
              history.push("/activeprocurement")
            }}
            className="btn btn-link btn-sm text-left"
            style={{ fontSize: "12px" }}
          >
            Show More
            <i className="fa fa-angle-double-right pl-2" aria-hidden="true" />
          </button>
        )}
      </div>
    )
  );
}
